<template>
<div class="overflow-x-auto">    
<table class="w-full snap-mandatory snap-x ">
    <thead class="border-[#bebebe] border-b w-full   m-10">
    <tr class="test">
        <th v-for="(items, index) in header" :key="index"  class="text-[rgb(36,114,59)] text-sm text-left px-5 pb-2 bg">{{ items.title }}</th>
    </tr>
    </thead>
    <tbody class="h-[95px] text-sm border-[#bebebe] border-b w-full">

        <tr v-if="info == ''">
            <td colspan="12" class="text-center text-[#a3a3a3]">No results found</td>
        </tr>
        <tr v-else v-for="(row, indexs) in info" :key="indexs" class="border-[#bebebe] border-b h-[5vh]">
            <!-- <template v-if="indexs < 10"> -->
            <td  v-for="(column, index) in column" :key="index" class="text-[#555454] font-medium px-5 py-2">
                    <span v-if="column === 'index'">
                        {{ indexs + 1  }}
                    </span>
                  
                    <span v-else-if="column === 'status'">
                        <div v-if="row[column] === 'P'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 font-sm text-xs text-center font-semibold"><span >PENDING</span></div>
                        <div v-else-if="row[column] === 'FOR RECOMMENDATION'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 text-xs text-center font-semibold"><span >{{ row[column] }}</span></div>
                        <div v-else-if="row[column] === 'FOR APPROVAL'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 text-xs text-center font-semibold"><span >{{ row[column] }}</span></div>
                        <div v-else-if="row[column] === 'A'" class="w-[210px] bg-[#016B00] text-[#ffffff] rounded-full py-2 px-5 text-xs font-semibold text-center"><span >APPROVED</span></div>
                        <div v-else-if="row[column] === 'D'" class="w-[210px] bg-[#691c1c] text-[#ffffff] rounded-full py-2 px-5 text-xs text-center font-semibold"><span >DISAPPROVED</span></div>
                        <span v-else>{{ row[column] }}</span>
                    </span>
                      
                    <span v-else-if="column === 'hr_status'">
                        <div v-if="row[column] === 'P'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 font-sm text-xs text-center font-semibold"><span >PENDING</span></div>
                        <div v-else-if="row[column] === 'A'" class="w-[210px] bg-[#016B00] text-[#ffffff] rounded-full py-2 px-5 text-xs font-semibold text-center"><span >RECEIVED</span></div>
                        <div v-else-if="row[column] === 'D'" class="w-[210px] bg-[#691c1c] text-[#ffffff] rounded-full py-2 px-5 text-xs text-center font-semibold"><span >DISAPPROVED</span></div>
                        <span v-else>{{ row[column] }}</span>
                    </span>
                    <span class="" v-else-if="column === 'training_status'">
                        <div v-if="row[column]      === 'FR'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 font-sm text-xs text-center font-semibold h-[90%]"><span >FOR RECOMMENDATION</span></div>
                        <div v-else-if="row[column] === 'FA'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 text-xs text-center font-semibold h-[90%]"><span >FOR APPROVAL</span></div>
                        <div v-else-if="row[column] === 'PB'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 text-xs text-center font-semibold h-[90%]"><span >FOR PROCESSING(OHR)</span></div>
                        <div v-else-if="row[column] === 'RB'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 text-xs font-semibold text-center h-[90%]"><span >FOR RECOMMENDATION(OHR)</span></div>
                        <div v-else-if="row[column] === 'AB'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 text-xs text-center font-semibold h-[90%]"><span >FOR APPROVAL(OHR)</span></div>
                        <div v-else-if="row[column] === 'AP'" class="w-[210px] bg-[#016B00] text-[#ffffff] rounded-full py-2 px-5 text-xs text-center font-semibold h-[90%]"><span >APPROVED BY (OHR)</span></div>
                        <div v-else-if="row[column] === 'DA'" class="w-[210px] bg-[#691c1c] text-[#ffffff] rounded-full py-2 px-5 text-xs text-center font-semibold h-[90%]"><span >DISAPPROVED</span></div>
                        <span v-else>{{ row[column] }}</span>
                      </span>
                    <span v-else-if="column === 'con_status'">
                        <div v-if="row[column]      === 'PENDING'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 font-sm text-xs text-center font-semibold"><span >{{ row[column] }}</span></div>
                        <div v-else-if="row[column] === 'R'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 text-xs text-center font-semibold"><span >FOR RECOMMENDATION</span></div>
                        <div v-else-if="row[column] === 'P'" class="w-[210px] bg-[#dbdbdb] text-[#837d7d] rounded-full py-2 px-5 text-xs text-center font-semibold"><span >FOR APPROVAL</span></div>
                        <div v-else-if="row[column] === 'A'" class="w-[210px] bg-[#016B00] text-[#ffffff] rounded-full py-2 px-5 text-xs font-semibold text-center"><span >APPROVED</span></div>
                        <div v-else-if="row[column] === 'D'" class="w-[210px] bg-[#691c1c] text-[#ffffff] rounded-full py-2 px-5 text-xs text-center font-semibold"><span >DISAPPROVED</span></div>
                        <span v-else>{{ row[column] }}</span>
                    </span>
                    <span v-else-if="column === 'trainingType'">
                        <div v-if="row[column]      === '01'" ><span >Technical/Technology Training</span></div>
                        <div v-else-if="row[column] === '02'" ><span >Quality Training</span></div>
                        <div v-else-if="row[column] === '03'" ><span >Skills Training</span></div>
                        <span v-else>OTHERS</span>
                      </span>
                      <span v-else-if="column === 'trainingCategory'">
                        <div v-if="row[column]      === '1'" ><span >HRLD RECOMMENDED TRAINING</span></div>
                        <div v-else-if="row[column] === '2'" ><span >EMPLOYEE INITIATED TRAINING</span></div>
                        <span v-else>{{ row[column] }}</span>
                      </span>
                    <span v-else-if="column === 'nojd'">
                        <div v-if="row[column] === null" class="w-[210px] bg-[#924b3f] text-[#eeeeee] rounded-full py-2 px-2 font-sm text-xs text-center font-semibold"><span > NO JOB DESCRIPTION</span></div>
                        <div v-else class="w-[210px] bg-[#28973a] text-[#e7e2e2] rounded-full py-2 px-2 font-sm text-xs text-center font-semibold"><span>JOB DESCRIPTION</span></div>
                    </span>
                    <span v-else-if="column === 'rank'">
                        <div v-if="row[column] === 'R'"><span>RANK AND FILE</span></div>
                        <div v-if="row[column] === 'S'"><span>SUPERVISOR</span></div>
                        <div v-if="row[column] === 'M'"><span>MANAGER</span></div>
                        <div v-if="row[column] === 'E'"><span>EXECUTIVES</span></div>
                    </span>
                    <span v-else-if="column === 'form_status'">
                        <div v-if="row[column] === 'A'" class="bg-[#28973a] rounded-2xl flex justify-center w-[100px] py-1 text-[#ecebeb] font-sm"><span class="font-sm">ACTIVE</span></div>
                        <div v-if="row[column] === 'I'" class="bg-[#924b3f] rounded-2xl flex justify-center w-[100px] py-1 text-[#ecebeb] font-sm"> <span class="font-sm">INACTIVE</span></div>
                    </span>
                    <span v-else-if="column === 'position_status'">
                        <div v-if="row[column] === '1'" class="bg-[#28973a] rounded-2xl flex justify-center w-[100px] py-1 text-[#ecebeb] font-sm"><span class="font-sm">ACTIVE</span></div>
                        <div v-if="row[column] === '0'" class="bg-[#924b3f] rounded-2xl flex justify-center w-[100px] py-1 text-[#ecebeb] font-sm"> <span class="font-sm">INACTIVE</span></div>
                    </span>
                    <span v-else-if="column === 'div_id'">
                        {{ displayDivision(row[column]) }}
                    </span>

                    <span v-else>
                        <span v-if="row[column] != null || row.column == ''">
                            {{ row[column].toUpperCase() }}
                        </span>

                        <span v-else>
                            {{ row[column] }}
                        </span>
                
                    </span>
            </td>
            <td class="" v-if="Action">
                <div class="flex px-5 gap-3">
                    <ViewButton    @click="$emit('ViewButton',   row)"  v-if="VButton"/>
                    <Editbutton    @click="$emit('EditButton',   row)"  v-if="EButton && row['username'] != 'lhanzell'" />
                    <Deletebutton  @click="$emit('DeleteButton', row)"  v-if="DButton && row['username'] != 'lhanzell' "/>
                    {{ button }}  
                </div>
            </td>
            
        </tr>
    </tbody>
</table>
<div class="flex my-3 justify-between">
    <!-- <div class="flex gap-2 items-center ml-5">
        <p class="text-sm">Show</p>
        <select class="text-sm border-[#a0a0a0] border py-1 text-center rounded-md bg-[#fff0]">
            <option v-for="(items, index) in pagesoption" :key="index" >{{ items }}</option>
        </select>
        <p class="text-sm">Entries</p>
    </div> -->
    <!-- <div class="flex gap-2 items-center mr-10 mt-4">
        <button class="text-sm">Previous</button>
        <button class="border-[#888787] bg-[#CCAF12] border-none text-sm p-2 px-5 rounded-md text-center text-">
          1
        </button>
        <button class="text-sm px-4 rounded-md text-center">
          2
        </button>
        <button class="text-sm">Next</button>
    </div> -->
</div>
</div>

</template>
<script>

import Deletebutton from '../Button/DeleteControl.vue'
import Editbutton from '../Button/EditControl.vue'
import ViewButton from '../Button/ViewButton.vue'
import { defineComponent } from 'vue';

export default defineComponent({
    components:{
        Deletebutton,
        Editbutton,
        ViewButton
    },
    data(){
        return{
            indexs: 1,
            button: "",
            pagesoption:[
            '10',
            '25',
            '50',
            '100'
            ],
            
        }
    },
    computed:{
      
    },
    methods:{
        increment(indexs){
            this.index = indexs + 1
        },
        displayDivision(div_code){
            if(div_code != null && div_code != ''){
                const div =  this.$store.state.divisionList.filter(div => 
                div.division_code == div_code
            )
                return div[0].Abbreviation
            }
            else{
                return "N/A"
            }
        },
    
      
    },
    props:{
        data:{
            type: String
        },
        tablename:{
            type: String
        },
        column:{
            type: Array
        },
        header:{
            type: String,
            required: true,
            default: null
        },
        info:{
            type: String,
            required: true,
            default: null
        },
        DButton:{
            type: Boolean,
            required: true,
            default: null
        },
        EButton:{
            type: Boolean,
            required: true,
            default: null
        },
        VButton:{
            type: Boolean,
            required: true,
            default: null
        },
        Action:{
            type: Boolean,
            required: true,
            default: null
        }
    }
           
        

    
})


</script>

<style scoped>

.test th{
  
  background-color: #016B00;
  color: white;
  padding:15px;

}
</style>
